import { Tag } from "primereact/tag";
import { PerilModelProfile } from "../../../client/types.gen";
import styles from "./CatCard.module.css";

// Explicit RMS pricing-source label from a peril's model profile — for places
// that show the source inline (e.g. the Layers-tab Source column / picker)
// rather than as a badge. Appends the version when known; otherwise plain
// "RMS". A null version is deliberately left unlabelled: it means either a
// version-shared HD model or an unrecognized profile, and we can't tell which.
export const rmsSourceLabel = (
  profile: PerilModelProfile | null | undefined
): string => {
  if (profile?.version === "22") return "RMS 22";
  if (profile?.version === "25") return "RMS 25";
  return "RMS";
};

// Small "RMS 22" / "RMS 25" pill for a peril's RMS model version. Renders
// nothing when there's no profile (older runs), or when the version is null
// (version-shared HD flood/wildfire, or an unrecognized profile) — never a
// "RMS null" placeholder.
export const RmsVersionBadge: React.FC<{
  profile: PerilModelProfile | null | undefined;
}> = ({ profile }) => {
  if (!profile || profile.version === null) {
    return null;
  }
  return (
    <Tag
      value={`RMS ${profile.version}`}
      severity={profile.version === "22" ? "warning" : "info"}
      className={styles.smallTag}
    />
  );
};
